/**
 * Bidirectional vertical scroll synchronization between two scrollable elements.
 *
 * Synchronous mirror with target-marker echo suppression: every user-driven
 * scroll on either element is mirrored to the other immediately, while the
 * reflexive scroll event from our own scrollTop write is consumed by a
 * single-slot marker.
 *
 * Ported from app/renderer/ui/rehearsal/scroll-sync.js (53-я). Returns a
 * detach() handle so callers can remove listeners on cleanup (e.g., the web
 * shell at <768px breakpoint when columns collapse into a single scroll
 * surface).
 *
 * @param {HTMLElement} elA First scrollable element.
 * @param {HTMLElement} elB Second scrollable element.
 * @returns {() => void} detach() — removes both listeners.
 */
export function attachScrollSync(elA, elB) {
  let echoTarget = null;

  const handleA = () => {
    if (echoTarget === elA) {
      echoTarget = null;
      return;
    }
    echoTarget = elB;
    elB.scrollTop = elA.scrollTop;
  };

  const handleB = () => {
    if (echoTarget === elB) {
      echoTarget = null;
      return;
    }
    echoTarget = elA;
    elA.scrollTop = elB.scrollTop;
  };

  elA.addEventListener('scroll', handleA, { passive: true });
  elB.addEventListener('scroll', handleB, { passive: true });

  return function detach() {
    elA.removeEventListener('scroll', handleA);
    elB.removeEventListener('scroll', handleB);
  };
}
